const PROD = {
  WS_URL: `ws://${window.location.host}/ws`,
  IMAGE_PREFIX: '',
  IS_DEBUG: false,
  LOG_STATE: false,
};

const DEBUG = {
  // WS_URL: 'ws://10.201.1.58:8088/ws',
  // WS_URL: 'ws://10.10.2.80:8088/ws',
  WS_URL: 'ws://10.10.2.80:8088/ws',
  // IMAGE_PREFIX: 'http://10.201.1.58:8088',
  // IMAGE_PREFIX: 'http://10.10.2.80:8088/',
  IMAGE_PREFIX: 'http://10.10.2.80:8088/',
  IS_DEBUG: true,
  LOG_STATE: false
};

const LOCAL = {
  WS_URL: 'ws://10.10.2.80:8088/ws',
  // IMAGE_PREFIX: 'http://10.201.1.58:8088',
  IMAGE_PREFIX: 'http://10.10.2.80:8088',
  IS_DEBUG: false,
  LOG_STATE: false,
};

// @ts-ignore
const isLocal = process.env.REACT_APP_IS_LOCAL === 'true';
// @ts-ignore
export const Configs = isLocal ? LOCAL : process.env.NODE_ENV === 'development' ? DEBUG : PROD;

